import * as React from "react";
import { ButtonGroup, Button, makeStyles, createStyles, Theme } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => {
  const labelFontSize = "0.6rem";

  return createStyles({
    root: {
      "position": "relative",

      "& .label": {
        position: "absolute",
        fontSize: labelFontSize,
        top: `calc(-${labelFontSize} - 2px)`,
        whiteSpace: "nowrap",
      },

      "&  .button-group": {
        color: theme.customPaper.background.contrast,
      },

      "& .MuiButton-outlined": {
        padding: theme.spacing(0.25, 2),
      },
    },

    enabled: {
      background: theme.palette.type != "dark" ? theme.customPaper.background.cardBackground : theme.customPaper.background.cardBackgroundLightContrast,
      color: theme.palette.common.white,
    },
  });
});

type ButtonSwitchProps = {
  label?: string;
  onLabel?: string;
  offLabel?: string;
  onClick: (newValue: boolean) => void;
  value: boolean;
};

function ButtonSwitch(props: ButtonSwitchProps) {
  const classes = useStyles();
  const { label, onLabel, offLabel, value, onClick } = props;

  return (
    <div className={classes.root}>
      <span className="label">{label}</span>
      <ButtonGroup>
        <Button
          className={clsx(!value ? classes.enabled : "button-group")}
          onClick={() => onClick(false)}
          disableElevation={!value}
        >
          {offLabel || "Não"}
        </Button>
        <Button
          className={clsx(value ? classes.enabled : "button-group")}
          onClick={() => onClick(true)}
          disableElevation={value}
        >
          {onLabel || "Sim"}
        </Button>
      </ButtonGroup>
    </div>
  );
}

export default ButtonSwitch;
